import { FatalErrorBoundary as FatalErrorBoundaryBase } from '@redwoodjs/web'

import { monitoring } from 'src/utils/monitoring'

import { EnvVariables, Environments } from '../../constants'

class FatalErrorBoundary extends FatalErrorBoundaryBase {
  componentDidCatch(error: unknown, context: Record<string, unknown>) {
    if (
      EnvVariables.Environment === Environments.Local ||
      EnvVariables.Environment === Environments.Development
    ) {
      return
    }
    monitoring.logError(error, context)
  }
}
export default FatalErrorBoundary
